/**
 * BottomLine — closing cheat-sheet block. The "walking into the meeting" glance
 * surface that every read ends on. (Reworked from the v10 "Part of Tens" block
 * — a literal For-Dummies book reference — with its 3px navy border and navy
 * filled header bar. Now: a hairline card with a crimson kicker and a Georgia
 * header. Component export name kept as PartOfTens for back-compat with the
 * ~9 read surfaces that import it.)
 */

import NumberedList from "./lists/NumberedList.jsx";

export default function PartOfTens({
  items,
  headerLabel = "The bottom line",
  subHeader = "The version you'd glance at on your phone walking in.",
}) {
  return (
    <div
      style={{
        marginTop: 40,
        border: "1px solid var(--ppr-color-border-default)",
        borderTop: "2px solid var(--ppr-color-accent-coral)",
        background: "var(--ppr-color-background-surface)",
        padding: "20px 24px",
      }}
      data-component="PartOfTens"
    >
      <div
        style={{
          fontFamily: "var(--ppr-typography-font-family-display)",
          fontSize: "var(--ppr-typography-font-size-lg)",
          fontWeight: "var(--ppr-typography-font-weight-regular)",
          letterSpacing: "var(--ppr-typography-letter-spacing-snug)",
          color: "var(--ppr-color-text-primary)",
          marginBottom: 4,
        }}
      >
        {headerLabel}
      </div>
      {subHeader ? (
        <div
          style={{
            fontFamily: "var(--ppr-typography-font-family-display)",
            fontSize: "14px",
            fontStyle: "italic",
            color: "var(--ppr-color-text-secondary)",
            marginBottom: 8,
          }}
        >
          {subHeader}
        </div>
      ) : null}
      <NumberedList items={items} />
    </div>
  );
}
